/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
        this.setAttribute("aria-expanded", this.classList.contains("active"));
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

/**************
 Scroll Hide/Show Header
 ***************/

let lastScrollY = window.scrollY;
let accumulatedScrollUp = 0;

// midpoint of the header in viewport coords, computed from layout so the
// translateY used by .headerHidden does not skew the result (otherwise the
// hidden header reports an off-screen rect and breaks intersection checks)
function getHeaderMid() {
    const headerGroup = document.querySelector('#headerGroup');
    const visualTop = Math.max(0, headerGroup.offsetTop - window.scrollY);
    return visualTop + headerGroup.offsetHeight / 2;
}

window.addEventListener("scroll", function () {
    const currentScrollY = window.scrollY;
    const headerGroup = document.querySelector('#headerGroup');

    // toggle blur backdrop only when scrolled away from the very top
    headerGroup.classList.toggle('scrolled', currentScrollY > 0);

    // opening the mega menu shifts layout and fires a spurious scroll event that
    // reads as "scrolling down" when not at the top, hiding the header out from
    // under the open menu — leave the header alone while the menu is open and
    // resync lastScrollY so delta tracking resumes cleanly once it closes
    const menuOpen = document.querySelector('.dropdownNavBody')?.classList.contains('active');
    if (menuOpen) {
        lastScrollY = currentScrollY;
        return;
    }

    // scrolling up
    if (currentScrollY < lastScrollY) {
        accumulatedScrollUp += (lastScrollY - currentScrollY);
        if (accumulatedScrollUp >= 50) {
            const headerMid = getHeaderMid();
            // check if we shouldn't show the header
            // we have a class noHeaderReveal to accomplish this (used on animated sections)
            const overNoReveal = Array.from(document.querySelectorAll('.noHeaderReveal')).some(el => {
                const rect = el.getBoundingClientRect();
                return headerMid >= rect.top && headerMid <= rect.bottom;
            });
            if (!overNoReveal) headerGroup.classList.remove('headerHidden');
            accumulatedScrollUp = 0;
        }
    } else {
        // scrolling down
        accumulatedScrollUp = 0;
        if (currentScrollY > 50) {
            headerGroup.classList.add('headerHidden');
        }
    }

    lastScrollY = currentScrollY;
});

/**************
 Light Header Detection
 ***************/

function updateHeaderLight() {
    const headerGroup = document.querySelector('#headerGroup');
    if (!headerGroup) return;

    const headerMid = getHeaderMid();

    // if the header is intersecting a showLightHeader section
    const isOverLight = Array.from(document.querySelectorAll('.showLightHeader')).some(section => {
        const rect = section.getBoundingClientRect();
        return headerMid >= rect.top && headerMid <= rect.bottom;
    });

    // Toggle light class
    headerGroup.classList.toggle('light', isOverLight);
}

window.addEventListener("scroll", updateHeaderLight);
// re-evaluate after the hide/show animation so the final state isn't stuck
// on whatever was true mid-transition (e.g. when scroll ends at the top)
document.querySelector('#headerGroup').addEventListener("transitionend", updateHeaderLight);
updateHeaderLight();


/**************
 Mega Menu
 ***************/
const menuTrigger = document.querySelector('.headerNavLink.openMenu');

if (menuTrigger) {
    const dropdownNav = document.querySelector('#dropdownNav');
    const dropdownItem = document.querySelector('.dropdownNavBody');
    const dropdownExit = document.querySelector('#dropdownExit');
    let menuCloseTimer = null;

    // open the dropdown and let keyboard users tab into its contents
    const openMenu = () => {
        clearTimeout(menuCloseTimer);
        menuTrigger.classList.add('active');
        dropdownItem.classList.add('active');
        dropdownExit.classList.add('active');
        menuTrigger.setAttribute('aria-expanded', 'true');
        dropdownNav.removeAttribute('inert');
    };

    // close the dropdown and pull it out of the tab order
    const closeMenu = () => {
        menuTrigger.classList.remove('active');
        dropdownItem.classList.remove('active');
        dropdownExit.classList.remove('active');
        menuTrigger.setAttribute('aria-expanded', 'false');
        dropdownNav.setAttribute('inert', '');
    };

    // focus we move ourselves (escape, shift+tab back out) must not re-open the menu
    let blockFocusOpen = false;

    const focusTrigger = () => {
        blockFocusOpen = true;
        menuTrigger.focus();
        blockFocusOpen = false;
    };

    menuTrigger.addEventListener('mouseenter', openMenu);

    // when a shop link is set the trigger is an anchor, so Enter navigates instead
    // of opening: tabbing onto it opens the menu so the keyboard path matches hover
    menuTrigger.addEventListener('focus', function () {
        if (blockFocusOpen || !menuTrigger.matches(':focus-visible')) {
            return;
        }
        openMenu();
    });

    // toggle on click, which Enter/Space on the button trigger natively
    menuTrigger.addEventListener('click', function () {
        dropdownItem.classList.contains('active') ? closeMenu() : openMenu();
    });

    dropdownExit.addEventListener('mouseenter', function () {
        menuCloseTimer = setTimeout(closeMenu, 150);
    });

    // immediate close when clicking the backdrop
    dropdownExit.addEventListener('click', closeMenu);

    dropdownNav.addEventListener('mouseenter', function () {
        clearTimeout(menuCloseTimer);
    });


    // collect focusable links inside the dropdown
    const getDropdownLinks = () => Array.from(dropdownNav.querySelectorAll('a, button'));

    // dropdown markup sits outside the nav in the DOM, so natural Tab skips
    // past it — redirect Tab from the trigger into the first dropdown link
    menuTrigger.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || e.shiftKey) {
            return;
        }
        if (!dropdownItem.classList.contains('active')) {
            return;
        }
        const links = getDropdownLinks();
        if (links.length === 0) {
            return;
        }
        e.preventDefault();
        links[0].focus();
    });

    // the dropdown is a disclosure, not a modal, so focus has to be able to leave it,
    // which means finding whatever the trigger would normally hand focus to next
    const focusAfterTrigger = () => {
        const headerFocusable = Array.from(document.querySelectorAll('#header a, #header button'))
            .filter(element => element.getClientRects().length > 0);
        const next = headerFocusable[headerFocusable.indexOf(menuTrigger) + 1];
        if (next) {
            next.focus();
        }
    };

    // tabbing off either end of the dropdown closes it and continues through the
    // page rather than trapping focus inside the menu
    dropdownNav.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') {
            return;
        }
        const links = getDropdownLinks();
        if (links.length === 0) {
            return;
        }
        const idx = links.indexOf(document.activeElement);
        if (idx === -1) {
            return;
        }

        // shift+tab off the first link goes back to the trigger
        if (e.shiftKey && idx === 0) {
            e.preventDefault();
            closeMenu();
            focusTrigger();
            return;
        }

        // tab off the last link moves on to the next header item
        if (!e.shiftKey && idx === links.length - 1) {
            e.preventDefault();
            closeMenu();
            focusAfterTrigger();
        }
    });

    // escape closes and returns focus to the trigger
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') {
            return;
        }
        if (!dropdownItem.classList.contains('active')) {
            return;
        }
        closeMenu();
        focusTrigger();
    });

    // close when focus leaves the trigger and the dropdown
    document.addEventListener('focusin', (e) => {
        if (!dropdownItem.classList.contains('active')) {
            return;
        }
        if (menuTrigger.contains(e.target) || dropdownNav.contains(e.target)) {
            return;
        }
        closeMenu();
    });
}

